/**
 * @desc 生产计划评审-BackToThe
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.BackToThe,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/wap/personal/plan/refuse',
    data,
  });
}

export function mock(data: defs.BackToThe): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/wap/personal/plan/refuse',
    data,
  });
}
